import _ from 'lodash';

export const getTotalValue = deliveries => _.reduce(deliveries, (acc, el) => acc + _.get(el, 'value', 0), 0) / 100;

export const getTotalDistance = deliveries => _.reduce(deliveries, (acc, el) => acc + _.get(el, 'distance', 0), 0);

export const toPriceStr = value => {
  const valueStr = _.toString(value.toFixed(2)).replace(/\./, ',');
  if (value) return `R$ ${valueStr}`;
  return 0;
};

